import { gql } from '@apollo/client';

export const BASE_ASK_RESPONSE = gql`
  fragment BaseAskResponse on Answer {
    answer
    sessionId
  }
`;

export const BASE_RATE_ANSWER_RESPONSE = gql`
  fragment BaseRateAnswerResponse on Rating {
    status
  }
`;

export const ASK_QUESTION = gql`
  mutation askQuestion($input: AskQuestionInput!) {
    askQuestion(input: $input) {
      ...BaseAskResponse
    }
  }
  ${BASE_ASK_RESPONSE}
`;

export const RATE_ANSWER = gql`
  mutation rateAnswer($input: RateAnswerInput!) {
    rateAnswer(input: $input) {
      ...BaseRateAnswerResponse
    }
  }
  ${BASE_RATE_ANSWER_RESPONSE}
`;

export const BASE_AI_CHAT_THREAD = gql`
  fragment BaseAIChatThread on AIChatThread {
    id
    title
    metadata
    createdDate
    updatedDate
  }
`;

export const BASE_AI_CHAT_MESSAGE = gql`
  fragment BaseAIChatMessage on AIChatMessage {
    id
    role
    metadata
    parts
  }
`;

export const AI_CHAT_THREAD = gql`
  query aiChatThread($id: ID!) {
    aiChatThread(id: $id) {
      ...BaseAIChatThread
    }
  }
  ${BASE_AI_CHAT_THREAD}
`;

export const AI_CHAT_THREAD_CREATE = gql`
  mutation aiChatThreadCreate($input: AIChatThreadCreateInput!) {
    aiChatThreadCreate(input: $input) {
      ...BaseAIChatThread
    }
  }
  ${BASE_AI_CHAT_THREAD}
`;

export const AI_CHAT_THREAD_UPDATE = gql`
  mutation aiChatThreadUpdate($input: AIChatThreadUpdateInput!) {
    aiChatThreadUpdate(input: $input) {
      ...BaseAIChatThread
    }
  }
  ${BASE_AI_CHAT_THREAD}
`;

export const AI_CHAT_THREAD_DELETE = gql`
  mutation aiChatThreadDelete($threadId: ID!) {
    aiChatThreadDelete(threadId: $threadId)
  }
`;

export const AI_CHAT_THREADS = gql`
  query aiChatThreads($input: AIChatThreadConnectionInput!) {
    aiChatThreads(input: $input) {
      totalCount
      threads {
        ...BaseAIChatThread
      }
    }
  }
  ${BASE_AI_CHAT_THREAD}
`;

export const AI_CHAT_MESSAGES = gql`
  query aiChatMessages($input: AIChatMessageConnectionInput!) {
    aiChatMessages(input: $input) {
      totalCount
      messages {
        ...BaseAIChatMessage
      }
    }
  }
  ${BASE_AI_CHAT_MESSAGE}
`;

export const BASE_AI_CHAT_MESSAGE_FEEDBACK = gql`
  fragment BaseAIChatMessageFeedback on AIChatMessageFeedback {
    id
    threadId
    messageId
    resourceId
    sentiment
    comment
    createdDate
    updatedDate
  }
`;

export const AI_CHAT_MESSAGE_FEEDBACK = gql`
  query aiChatMessageFeedback($input: AIChatMessageFeedbackConnectionInput!) {
    aiChatMessageFeedback(input: $input) {
      totalCount
      feedback {
        ...BaseAIChatMessageFeedback
      }
    }
  }
  ${BASE_AI_CHAT_MESSAGE_FEEDBACK}
`;

export const AI_CHAT_MESSAGE_FEEDBACK_UPSERT = gql`
  mutation aiChatMessageFeedbackUpsert(
    $input: AIChatMessageFeedbackUpsertInput!
  ) {
    aiChatMessageFeedbackUpsert(input: $input) {
      ...BaseAIChatMessageFeedback
    }
  }
  ${BASE_AI_CHAT_MESSAGE_FEEDBACK}
`;

export const AI_CHAT_TOOL_EXPORT_CREATE = gql`
  mutation aiChatToolExportCreate($input: AIChatToolExportCreateInput!) {
    aiChatToolExportCreate(input: $input) {
      fileName
      url
    }
  }
`;

export const AI_CHAT_TOOL_CALL_UPDATE = gql`
  mutation aiChatToolCallUpdate($input: AIChatToolCallUpdateInput!) {
    aiChatToolCallUpdate(input: $input)
  }
`;

export const AI_CHAT_MODELS = gql`
  query aiChatModels {
    aiChatModels {
      default {
        id
        name
      }
      models {
        id
        name
      }
    }
  }
`;
